module.exports = __webpack_public_path__ + "static/media/gabby.89bb26ad.png";